import unescapedText from 'I18n/utils/unescapedText';
import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { View } from 'foundations-components/transitional/components/View';
import { HR } from 'foundations-components/transitional/components/HR';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SettingsForm({
  loginVerifyData
}) {
  const EMPTY_PLACEHOLDER = '\u2014';
  const fullName = [loginVerifyData.firstname, loginVerifyData.lastname].filter(Boolean).join(' ') || EMPTY_PLACEHOLDER;
  const jobTitle = loginVerifyData.jobTitle || EMPTY_PLACEHOLDER;
  const phone = loginVerifyData.phone || EMPTY_PLACEHOLDER;
  return /*#__PURE__*/_jsx(View, {
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-50",
        color: "text-core-default",
        marginBlockStart: "300",
        marginBlockEnd: "300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.myAccountPopover.settings.profile.title"
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "200",
        flexGrow: 1,
        minInlineSize: "0",
        children: /*#__PURE__*/_jsx(FormControl, {
          label: unescapedText('app.myAccountPopover.settings.profile.fullNameLabel'),
          children: /*#__PURE__*/_jsx(TextInput, {
            name: "fullName",
            value: fullName,
            typography: "body-100",
            readOnly: true,
            disabled: true
          })
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "200",
        flexGrow: 1,
        minInlineSize: "0",
        children: /*#__PURE__*/_jsx(FormControl, {
          label: unescapedText('app.myAccountPopover.settings.profile.jobTitleLabel'),
          children: /*#__PURE__*/_jsx(TextInput, {
            name: "jobTitle",
            value: jobTitle,
            typography: "body-100",
            readOnly: true,
            disabled: true
          })
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormControl, {
          label: unescapedText('app.myAccountPopover.settings.profile.phoneLabel'),
          children: /*#__PURE__*/_jsx(TextInput, {
            name: "phone",
            value: phone,
            typography: "body-100",
            readOnly: true,
            disabled: true
          })
        })
      })]
    })
  });
}
export function SettingsPanel({
  open,
  onClose,
  loginVerifyData
}) {
  if (!open) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Panel, {
    width: 550,
    children: [/*#__PURE__*/_jsx(CloseButton, {
      onClick: onClose,
      color: "text-core-default"
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsxs(PanelSection, {
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          color: "text-core-default",
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.myAccountPopover.settings.heading"
          })
        }), /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          color: "text-core-default",
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.myAccountPopover.settings.subtitle"
          })
        }), /*#__PURE__*/_jsx(HR, {
          distance: "flush"
        }), /*#__PURE__*/_jsx(SettingsForm, {
          loginVerifyData: loginVerifyData
        })]
      })
    })]
  });
}